export var baseColorKeys = ['primary', 'secondary', 'positive', 'warning', 'negative', 'magic'];